import { commonProducts } from "../assets/data/commonProducts.js";
import { getCommonProductsReducer, getCommonProductByIdReducer, filterByBrandReducer, filterByCategoryReducer } from "./commonProductSlice.js";

export const getCommonProducts = () => {
    return (dispatch) => {
        dispatch(getCommonProductsReducer(commonProducts));
    };
};

export const getCommonProductById = (productId) => {
    return (dispatch) => {
        dispatch(getCommonProductByIdReducer(productId))
    };
};

export const filterByBrand = (rooms) => {
    return async (dispatch) => {
        dispatch(filterByBrandReducer(rooms));
    };
};

export const filterByCategory = (type) => {
    return async (dispatch) => {
        dispatch(filterByCategoryReducer(type));
    };
};

// export const orderByPrice = (order) => {
//     return async (dispatch) => {
//         dispatch(orderByPriceReducer(order));
//     };
// };